// Daily Traffic Dashboards Default

export const rentalTypes = [
    { id: "HOLIDAY_APARTMENT", name: "Ferienwohnung" },
    { id: "HOLIDAY_HOUSE", name: "Ferienhaus" },
    { id: "PREMIUM_ACCOMMODATION", name: "Premium-Unterkunft" },
    { id: "WINERY", name: "Weingut" },
    { id: "BED_AND_BREAKFAST", name: "Bed & Breakfast" },
    { id: "BOAT", name: "Hausboot" },
    { id: "LOG_CABIN", name: "Blockhütte" },
    { id: "GUEST_HOUSE", name: "Gästehaus" },
    { id: "FARM_STAY", name: "Auf dem Bauernhof" },
    { id: "THATCHED_HOUSE", name: "Reetgedecktes Haus" },
    { id: "BOARDINGHOUSE", name: "Boardinghouse" },
    { id: "FARMHOUSE", name: "Bauernhaus" },
    { id: "LUXURY_VILLA", name: "Luxusvilla" },
    { id: "CHALET", name: "Chalet" },
    { id: "TINY_HOUSE", name: "Tiny House" },
    { id: "TOWNHOUSE", name: "Stadthaus" },
    { id: "CAMPING_SUITE", name: "Campingplatz / Zeltplatz" },
    { id: "GLAMPING", name: "Glamping" },
    { id: "CABIN", name: "Hütte" },
    { id: "VILLA_BY_THE_SEA", name: "Villa am Meer" },
    { id: "MOUNTAIN_HUT", name: "Berghütte" },
    { id: "HOUSE_BY_THE_LAKE", name: "Haus am See" },
    { id: "YOUTH_HOSTEL", name: "Jugendherberge" },
    { id: "GUESTHOUSE", name: "Pension" },
    { id: "HOSTEL", name: "Hostel" },
    { id: "HOTEL", name: "Hotel" },
    { id: "MOTEL", name: "Motel" },
    { id: "BUNGALOW", name: "Bungalow" },
    { id: "APARTMENT", name: "Apartment" },
    { id: "APARTHOTEL", name: "Aparthotel" },
    { id: "LOFT", name: "Loft" },
    { id: "CASTLE", name: "Schloss" },
    { id: "VILLA_IN_THE_MOUNTAINS", name: "Villa in den Bergen" },
    { id: "YURT", name: "Jurte" },
    { id: "TIPI", name: "Tipi" },
    { id: "TREEHOUSE", name: "Baumhaus" },
    { id: "SAFARI_LODGE", name: "Safari-Lodge" },
    { id: "BEACH_HUT", name: "Strandhütte" },
    { id: "HOUSE_IN_THE_DUNES", name: "Haus in den Dünen" },
    { id: "CAPSULE_HOTEL", name: "Kapselhotel" },
    { id: "MONASTERY_ACCOMMODATION", name: "Klosterunterkunft" },
    { id: "MOUNTAIN_CABIN", name: "Almhütte" },
    { id: "FISHERMAN_HUT", name: "Fischerhütte" },
    { id: "MOTORHOME", name: "Wohnmobil" },
    { id: "FINCA", name: "Finca" },
    { id: "TRULLI", name: "Trulli" },
    { id: "RORBU", name: "Rorbu" },
    { id: "BARN", name: "Scheune" }
];
